export default __webpack_public_path__ + "static/media/gerjan02.bed2585c.png";